module.exports = __webpack_public_path__ + "img/spot-green-23.png";